/**
 * Created by andrey on 20.02.18.
 */

const HintBooster = function (id) {
    Booster.call(this, id);
};

HintBooster.prototype = Object.create(Booster.prototype);
HintBooster.prototype.constructor = HintBooster;

HintBooster.prototype.findHint = function () {
    const game = Game.currentGame;

    if (cleverapps.config.subtype === "stacks") {
        return game.keypad.selectHintPosition();
    }
    return game.board.selectHintPosition();
};

HintBooster.prototype.addHint = function (hint, options) {
    const game = Game.currentGame;

    options = options || {};

    const hintAnimationDuration = 0.3;
    const hintAnimationTimeout = hintAnimationDuration + 0.5;

    if (["scramble"].indexOf(cleverapps.config.name) === -1) {
        game.board.addHint(hint.row, hint.column);
        game.counter.setTimeout(() => {}, hintAnimationTimeout * 1000);
        return;
    }

    if (!hint.letter) {
        return;
    }

    hint.letter.setHint(true, {
        hintAnimationDuration: options.hintAnimationDuration || hintAnimationDuration,
        startPos: options.startPos
    });

    const boardIndex = game.board.listWordIndexes(hint.word)[hint.index];
    game.counter.setTimeout(() => {
        game.board.addHint(boardIndex[0], boardIndex[1]);
    }, hintAnimationTimeout * 1000);
};

HintBooster.prototype.onExecute = function () {
    const hint = this.findHint();
    if (hint) {
        this.addHint(hint);
    } else {
        this.trigger("noHintFound");
    }
};